<template>
  <div class="waitlist">
    <div class="wrapper m-0 p-0">
      <h5>Waitlist Funnel ({{ totalCount }})</h5>
    </div>
    <div class="card-deck scrolling-wrapper my-3 co-md-12">
      <div
        class="card col-4 p-2 row show_hand news"
        v-bind:class="{ active_card: status == 18 }"
        v-on:click="changestatus(18)"
      >
        <div class="col-md-8 m-0 p-0 pt-2 text-left">
          <div @drop="openModalbydrag(0, 'New')" class="drop d-flex">
            <h6>
              <p class="m-0 p-0" v-if="loading && waitlist.length == 0">
                Loading..
              </p>
              <span v-else>{{ waitlist_count.new }}</span>
              New.
            </h6>
          </div>
        </div>
        <div class="wrapper-progress text-center">
          <div class="progress" v-bind:style="{ width: newCount + '%' }">
            <span class="percent-progress">{{ newCount }}%</span>
          </div>
        </div>
      </div>
      <div
        class="card col-4 p-2 show_hand row"
        v-bind:class="{ active_card: status == 19 }"
        v-on:click="changestatus(19)"
      >
        <div class="col-md-8 m-0 p-0 pt-2 text-left">
          <div @drop="openModalbydrag(19, 'Postponed')" class="drop d-flex">
            <h6>
              <p class="m-0 p-0" v-if="loading && waitlist.length == 0">
                Loading..
              </p>
              <span v-else>{{ waitlist_count.postponed }}</span>
              Postponed.
            </h6>
          </div>
        </div>
        <div class="wrapper-progress text-center">
          <div class="progress" v-bind:style="{ width: postponedCount + '%' }">
            <span class="percent-progress">{{ postponedCount }}%</span>
          </div>
        </div>
      </div>
      <div
        class="card col-4 p-2 row show_hand"
        v-bind:class="{ active_card: status == 20 }"
        v-on:click="changestatus(20)"
      >
        <div class="col-md-8 m-0 p-0 pt-2 text-left">
          <div @drop="openModalbydrag(20, 'Action Taken')" class="drop d-flex">
            <h6>
              <p class="m-0 p-0" v-if="loading && waitlist.length == 0">
                Loading..
              </p>
              <span v-else>{{ waitlist_count.action_taken }}</span>
              Action Taken.
            </h6>
          </div>
        </div>
        <div class="wrapper-progress text-center">
          <div
            class="progress"
            v-bind:style="{ width: action_takenCount + '%' }"
          >
            <span class="percent-progress">{{ action_takenCount }}%</span>
          </div>
        </div>
      </div>
      <div
        class="card col-4 p-2 row show_hand"
        v-bind:class="{ active_card: status == 21 }"
        v-on:click="changestatus(21)"
      >
        <div class="col-md-8 m-0 p-0 pt-2 text-left">
          <div @drop="openModalbydrag(21, 'Closed')" class="drop d-flex">
            <h6>
              <p class="m-0 p-0" v-if="loading && waitlist.length == 0">
                Loading..
              </p>
              <span v-else>{{ waitlist_count.not_interested }}</span>
              Not Interested.
            </h6>
          </div>
        </div>
        <div class="wrapper-progress text-center">
          <div
            class="progress"
            v-bind:style="{ width: notInterestedCount + '%' }"
          >
            <span class="percent-progress">{{ notInterestedCount }}%</span>
          </div>
        </div>
      </div>

      <div
        class="card col-4 p-2 row show_hand"
        v-bind:class="{ active_card: status == 22 }"
        v-on:click="changestatus(22)"
      >
        <div class="col-md-8 m-0 p-0 pt-2 text-left">
          <div @drop="openModalbydrag(22, 'Closed')" class="drop d-flex">
            <h6>
              <p class="m-0 p-0" v-if="loading && waitlist.length == 0">
                Loading..
              </p>
              <span v-else>{{ waitlist_count.successful }}</span>
              Converted.
            </h6>
          </div>
        </div>
        <div class="wrapper-progress text-center">
          <div class="progress" v-bind:style="{ width: sucessCount + '%' }">
            <span class="percent-progress">{{ sucessCount }}%</span>
          </div>
        </div>
      </div>
      <!--
                  <div class="card col-4 p-2 row show_hand"  v-bind:class="{ active_card: status == 10 }" v-on:click="changestatus(10)">
                        <div class="col-md-8 m-0 p-0 pt-2 text-left">
                        <div @drop="openModalbydrag(10, 'Closed')" class="drop d-flex">
                         <h6>
                            <p class="m-0 p-0" v-if="loading  && waitlist.length == 0">Loading..</p>
                            <span v-else>{{waitlist_count.squadVoice}}</span>
                            Squad Voice
                          </h6>
                        </div>
                        </div>
                        <div class="wrapper-progress text-center"> 
                          <div class="progress" v-bind:style="{width: squadVoiceCount + '%' }">
                            <span class="percent-progress">{{squadVoiceCount}}%</span>
                          </div>
                        </div>
                  </div>
                  -->
    </div>

    <div
      class="col-md-12 m-0 mb-3 p-0 d-flex justify-content-between filtering"
    >
      <div class="filter m-0 p-0 d-flex">
        <!-- <label class="mt-2" for="sortby px-3">Model:</label> -->
        <select v-model="model_selected" class="form-control p-1 mr-2">
          <option disabled value="">Select Model</option>
          <option value="">Load All</option>
          <option v-for="(data, index) in models" :key="index">
            {{ data.name }}
          </option>
        </select>
      </div>
      <div class="filter m-0 p-0 d-flex">
        <!-- <label class="mt-2" for="sortby px-3">Model:</label> -->
        <input
          type="text"
          v-model="search"
          placeholder="search.."
          class="form-control p-1 mx-2"
        />
      </div>
      <div class="filter m-0 p-0 d-flex">
        <label class="mt-2" for="sortby px-3">Limit:</label>
        <select v-model="limit" class="form-control p-1 mx-2">
          <option :value="waitlist.length">Load All</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
        </select>
      </div>
      <div class="date_picker d-flex m-0 pr-0">
        <label class="mt-2 ml-2" for="datefrom">Start: </label
        ><input v-model="fromDate" type="date" class="form-control mx-2" />
        <label class="mt-2 ml-2" for="dateTo">End:</label
        ><input type="date" class="form-control ml-2" v-model="toDate" />
        <!-- <input type="button" class="button-on form-control ml-2 mr-0" value="Fetch"> -->
      </div>
    </div>
    <div class="col-md-12 m-0 p-0 col-12">
      <p class="percentage" v-if="model_selected">
        Total {{ waitlist_filtered.length }}
        <strong>{{ model_selected }}</strong
        >, {{ Percentage_total }}% of Total Funnel &
        <span v-if="status === 0">{{ percentage_new }}% of New.</span>
        <span v-if="status === 1">{{ percentage_postponed }}% Postponed</span>
        <span v-if="status === 2"
          >{{ percentage_underAction }}% Under Action</span
        >
        <span v-if="status === 3"
          >{{ percentage_not_interested }}% Not Interested</span
        >
        <span v-if="status === 4">{{ percentage_success }}% Successful</span>
      </p>
    </div>

    <div
      class="col-md-12 m-0 p-0 mb-2 justify-content-between"
      style="display:flex;justify-content:in-between"
      v-if="selectedItem"
    >
      <div class="d-flex">
        <div class="btn-group dropright">
          <button
            v-b-tooltip.hover
            title="Change Status"
            type="button"
            class="btn handy dropdown-toggle m-0 p-1"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Change Status
          </button>
          <div class="dropdown-menu">
            <a
              class="dropdown-item"
              v-on:click="
                openChangeStatusModel(
                  selectedItem.id,
                  18,
                  'New',
                  selectedItem.comment,
                  selectedItem.customerId
                )
              "
              >Flag New</a
            >
            <a
              class="dropdown-item"
              v-on:click="
                openChangeStatusModel(
                  selectedItem.id,
                  19,
                  'Postpond',
                  selectedItem.comment,
                  selectedItem.customerId
                )
              "
              >Postpone</a
            >
            <a
              class="dropdown-item"
              v-on:click="
                openChangeStatusModel(
                  selectedItem.id,
                  20,
                  'Action Taken',
                  selectedItem.comment,
                  selectedItem.customerId
                )
              "
              >Flag Under Action</a
            >
            <a
              class="dropdown-item"
              v-on:click="
                openChangeStatusModel(
                  selectedItem.id,
                  21,
                  'Not Interested',
                  selectedItem.comment,
                  selectedItem.customerId
                )
              "
              >Flag Not Interested</a
            >
            <a
              class="dropdown-item"
              v-on:click="
                openChangeStatusModel(
                  selectedItem.id,
                  22,
                  'Successful',
                  selectedItem.comment,
                  selectedItem.customerId
                )
              "
              >Flag Successful</a
            >
            <!-- <a class="dropdown-item" v-on:click="opensmsModal(data.id, data.mobile)">Send SMS</a> -->
          </div>
        </div>
        <div class="ml-4">
          <i
            v-b-tooltip.hover
            title="Send Sms"
            class="fa fa-envelope p-2 hand2"
            v-on:click="
              opensmsModal(
                selectedItem.id,
                selectedItem.mobile,
                selectedItem.name,
                selectedItem.model
              )
            "
            aria-hidden="true"
          >
          </i>
        </div>
        <!--
    <div class="ml-4">
       <i id="tooltip2" class="fa fa-phone p-2 hand2" v-on:click="squadVoice()" aria-hidden="true" >
         <span>Squad Voice</span>
       </i>
    </div>
    -->
      </div>
      <div class="ml-4">
        <p class="hand2 m-0 p-2">
          Selected: {{ selectedItem.customerId }}
          <span class="cancel p-1 mr-0 ml-2" @click="reset">X</span>
        </p>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <!-- <th><i class="fa fa-arrows" aria-hidden="true"></i></th> -->
            <!-- <th scope="col">ID</th> -->
            <th scope="col no-pad">
              <!-- <span class="hand2 p-2" v-if="selectedItem" @click="reset">X</span> -->
            </th>
            <!-- <th scope="col">ID</th> -->
            <th style="white-space: nowrap;" scope="col">Name</th>
            <th scope="col">Email</th>
            <th scope="col">Phone</th>
            <th scope="col" class="pl-2">Vehicle</th>
            <th scope="col">Date</th>
            <th>Cx Status</th>
            <!-- <th scope="col">Status</th>
        <th>SMS</th> -->
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(data, index) in limited"
            :key="index"
            v-bind:class="{ selected: selectedItem == data }"
          >
            <!-- <drag @drag="setid(data)"  class="drag"><td><i class="fa fa-arrows" aria-hidden="true"></i></td></drag> -->
            <!-- <td>{{data.id}}</td> -->
            <td>
              <input
                type="radio"
                v-model="selectedItem"
                id="selected_item"
                :value="data"
              />
            </td>
            <!-- <td
              v-b-tooltip.hover
              :title="data.comment || 'No Comment'"
              class="hand"
              v-if="data.comment"
            >
              {{ data.customerId }}
            </td> -->
            <!-- <td id="tooltip1" class="hand" v-else>
              {{ data.customerId }}
              <span>No comment yet.</span>
            </td> -->

            <!-- <td id="tooltip1" class="hand">{{data.customerId}}<span v-if="data.comment">{{data.comment}}</span>
        <span v-else>No Comment yet...</span>
        </td> -->
            <td class="link" @click="openProfile(data.customerId, data.mobile)">
              {{ data.name }}
            </td>
            <td>{{ data.emailId }}</td>
            <td class="my-2 py-2" v-b-tooltip.hover="checkVariant(data.customerData.activeStatus)[0].description" >
             
                <a
                  class="px-2 py-1"
                  v-bind:style="{'background': checkVariant(data.customerData.activeStatus)[0].color}"
                  style="text-decoration:none;color:white"
                  :href="'tel:' + data.mobile"
                  >{{ data.mobile }}</a
                >
            </td>
            <td style="white-space: nowrap;">
              <img
                class="img-responsive ml-2"
                v-if="checkModel('Yamaha', data.model)"
                src="src/assets/yamaha.svg"
                width="15px"
              />
              <img
                class="img-responsive ml-2"
                v-if="checkModel('Honda', data.model)"
                src="src/assets/honda.svg"
                width="15px"
              />
              <img
                class="img-responsive ml-2"
                v-if="checkModel('TVS', data.model)"
                src="src/assets/tvs-logo.svg"
                width="15px"
              />
              <img
                class="img-responsive ml-2"
                v-if="checkModel('Suzuki', data.model)"
                src="src/assets/suzuki.svg"
                width="15px"
              />
              <img
                class="img-responsive ml-2"
                v-if="checkModel('Hero', data.model)"
                src="src/assets/hero.svg"
                width="15px"
              />
              <img
                class="img-responsive ml-2"
                v-if="checkModel('Bajaj', data.model)"
                src="src/assets/bajaj.png"
                width="15px"
              />
              <img
                class="img-responsive ml-2"
                v-if="checkModel('Aprilia', data.model)"
                src="src/assets/aprilia1.png"
                width="15px"
              />
              {{ data.model }}
            </td>
            <td style="white-space: nowrap;">
              {{ data.createdAt | moment("from", "now") }}
            </td>
            <td style="white-space: nowrap;">
              <div v-if="data.customerData">
                <span class="badge badge-info" v-if="data.customerData.status == 0">New</span>
                <span class="badge badge-success" v-if="data.customerData.status == 1"
                  >Ongoing</span
                >
                <span class="badge badge-danger" v-if="data.customerData.status == 2"
                  >Dropped</span
                >
              </div>
              <div v-else>
                <span class="badge badge-danger"
                  >Not Identified</span
                >
              </div>

            </td>
            <!-- <td>
          <div class="btn-group dropleft">
            <button id="tooltip2" type="button" class="btn dropdown-toggle m-0 p-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Change Status
              <span v-if="data.status === 0">Current Status New</span>
                  <span v-if="data.status === 1">Current Status Postponed</span>
                  <span v-if="data.status === 2">Current Status Under Action</span>
                  <span v-if="data.status === 3">Current Status Not Interested</span>
                  <span v-if="data.status === 4">Current Status Successful</span>

            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" v-on:click="openModal(data.id, 0, 'New', data.comment)">Flag New</a>
              <a class="dropdown-item" v-on:click="openModal(data.id, 1, 'Postpond', data.comment)">Postpone</a>
              <a class="dropdown-item" v-on:click="openModal(data.id, 2, 'Action Taken', data.comment)">Flag Under Action</a>
              <a class="dropdown-item" v-on:click="openModal(data.id, 3, 'Not Interested', data.comment)">Flag Not Interested</a>
              <a class="dropdown-item" v-on:click="openModal(data.id, 4, 'Successful', data.comment)">Flag Successful</a>
            </div>
          </div>
        </td>
      <td class="hand text-center">
            <i v-on:click="opensmsModal(data.id, data.mobile, data.name, data.model)" class="fa fa-envelope pt-2" aria-hidden="true"></i>
            <i v-on:click="sendPromition(data.customerId, data.mobile)" class="fa fa-bell pt-2 ml-3" aria-hidden="true"></i>
      </td> -->
          </tr>
        </tbody>
      </table>
      <div v-if="loading && waitlist.length == 0" class="mt-5 text-center">
        <img src="src/assets/ontrackloader.gif" width="50px" alt="" />
        <p><span class="highlight">Hold up tight.</span></p>
        <p><span class="highlight">Your data is being loaded.</span></p>
      </div>

      <div v-if="!loading && waitlist.length == 0" class="mt-5 text-center">
        <img src="src/assets/ok.svg" width="50px" alt="" />
        <p>
          <span class="highlight"
            >woooahhhh we have a clear plus booking funnel..</span
          >
        </p>
        <p><span class="highlight">Great!!!!</span></p>
      </div>
    </div>
    <div
      id="mymodals"
      class="modals"
      v-bind:class="{ displayModal: showModal }"
    >
      <!-- modals content -->
      <div class="modals-content p-0 mt-5">
        <div class="modal-heading m-0 p-3 d-flex justify-content-between">
          <h6 class="m-0 p-0">
            Hey {{ username }}, are you sure to change status to {{ action }}?
          </h6>
          <img
            v-on:click="closeModal"
            class="hand m-0 p-0"
            src="src/assets/close.svg"
            width="15px"
            alt=""
          />
        </div>

        <div
          class="col-md-12 m-0 p-3 pt-0 mb-3 previousComment"
          id="container"
          v-if="commentData.length > 0"
        >
          <p class="m-0 p-0 pb-2">Previous Comments:</p>
          <div
            class="card col-md-8 p-2 mb-2"
            v-for="(data, index) in commentData"
            :key="index"
          >
            <p class="comment p-0 m-0">{{ data.comment }}</p>
            <div class="discription d-flex justify-content-between">
              <p class="p-0 m-0 labels">
                {{ data.createdAt | moment("from", "now") }}
              </p>
              <p class="p-0 m-0 labels">{{ data.userName }}</p>
            </div>
          </div>
        </div>
        <div class="text-center no-comments col-md-12" v-else>
          <img src="src/assets/no.svg" width="100px" class="my-3" />
          <p>No comments yet.</p>
        </div>

        <div class="remind row px-3">
          <div class="col-md-6">
            <label for="remind" class="label">I want a reminder?</label>
            <input v-model="remind" name="remind" type="checkbox" />
          </div>
          <div class="col-md-6">
            <label v-if="takeDate" for="calender"
              >When to remind you?
              <input
                class="form-control"
                type="date"
                v-if="takeDate"
                v-model="reminder_date"
              />
            </label>
          </div>
        </div>

        <div class="px-3">
          <textarea
            type="text"
            v-model="comment"
            placeholder="comment.."
            class="text-area form-control"
          ></textarea>
        </div>
        <div class="modal-footer" style="border:none">
          <button v-on:click="change_status()" class="ontrack-button">
            <span v-if="changing">Wait...</span>
            <span v-else>I'm, Sure!</span>
          </button>
        </div>
      </div>
    </div>

    <div
      id="mymodals"
      class="modals"
      v-bind:class="{ displayModal: showsmsModal }"
    >
      <!-- modals content -->
      <div class="modals-content-90 mt-5">
        <div class="row col-md-12 m-0 p-0">
          <div class="col-md-12 m-0 p-0 mb-2">
            Sending sms to
            <input
              type="text"
              ref="typeBox"
              class="phone_input"
              v-bind="{ show_edit: showEdit }"
              v-model="send_sms_mobile"
            />
            <i
              class="fa fa-pencil size_12 hand"
              v-on:click="editMobile"
              aria-hidden="true"
            ></i>
            <span class="close" v-on:click="closeSmsModal">&times;</span>
          </div>
          <div class="col-md-8">
            <div class="col-md-12 my-3 m-0 p-0 previous">
              <div
                class="card border col-md-8 p-2 mb-2"
                v-for="(data, index) in message_sent"
                :key="index"
              >
                <p class="sms p-0 m-0">{{ data.sms }}</p>
                <div class="discription d-flex justify-content-between">
                  <p class="p-0 m-0">
                    {{ data.createdAt | moment("from", "now") }}
                  </p>
                  <p class="p-0 m-0">{{ data.agent }}</p>
                </div>
              </div>
              <div class="loading text-center my-5" v-if="loadingChat">
                <div class="spinner-grow text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div class="spinner-grow text-success" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <p>Loading Chat History</p>
              </div>
              <div
                class="initiate text-center my-5"
                v-if="!loadingChat && message_sent.length == 0"
              >
                <i class="fa fa-commenting-o" aria-hidden="true"></i>
                <p>We haven't sent any SMS to the customer.</p>
                <p class="m-0 p-0">
                  Start Sending now
                  <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                </p>
              </div>
            </div>
            <div class="">
              <textarea
                type="text"
                rows="6"
                cols="80"
                v-model="sms"
                placeholder="type message.."
                class="text-area form-control"
              ></textarea>
            </div>
            <div class="modal-footer uk-clearfix">
              <button v-on:click="sendMessage()" class="ontrack-button">
                <span v-if="sendingsms">Sending.....</span>
                <span v-else>Send Message</span>
              </button>
            </div>
          </div>
          <div class="col-md-4 templates border-left">
            <div
              class="card mb-2 p-2 hand"
              @click="load(data.id)"
              v-for="(data, index) in templates"
              :key="index"
            >
              <p class="tag m-0 p-0">//{{ data.tag }}</p>
              <p class="m-0 p-0">
                {{ data.temp }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="mymodals"
      class="modals"
      v-bind:class="{ displayModal: loadingComments }"
    >
      <div class="modals-content-loading text-center p-0 mt-5">
        <img src="src/assets/ontrackloader.gif" width="50px" alt="" />
      </div>
    </div>
    <div
      id="mymodals"
      class="modals"
      v-bind:class="{ displayModal: sendSquadModel }"
    >
      <div class="modals-content p-0 mt-3">
        <div class="modal-heading m-0 p-3 d-flex justify-content-between">
          <h6 class="m-0 p-0">
            Hey {{ username }}, are you sure to sent lead to SquadVoice?
          </h6>
          <img
            v-on:click="sendSquadModel = !sendSquadModel"
            class="hand m-0 p-0"
            src="src/assets/close.svg"
            width="15px"
            alt=""
          />
        </div>

        <div class="col-md-12 m-0 py-3">
          <div class="row m-0 p-0">
            <div class="col-md-4 m-0 p-0">
              <p>Lead ID: {{ selectedItem.id }}</p>
            </div>
            <div class="col-md-4 m-0 p-0">
              <p>Name: {{ selectedItem.name }}</p>
            </div>
            <div class="col-md-4 m-0 p-0">
              <p>Phone: {{ selectedItem.mobile }}</p>
            </div>
            <div class="col-md-4 m-0 p-0">
              <p>Email: {{ selectedItem.emailId }}</p>
            </div>
            <!--<div class="col-md-4 m-0 p-0">
                  <p>Rental:  {{rental}}</p>
                  </div>-->
            <div class="col-md-4 m-0 p-0">
              <p>Vehicle: {{ selectedItem.model }}</p>
            </div>
          </div>

          <hr />
          <label class="mr-1 m-0 p-0" for="amount"
            >Additional Note to SV
            <textarea
              type="text"
              class="form-control"
              v-model="additional_notes"
              placeholder=""
            ></textarea>
          </label>
          <!--
                  <label class="mr-1 m-0 p-0" for="amount">Not Intersted Reason
                  <textarea type="text" class="form-control" v-model="not_interested_reason"  placeholder=""></textarea>
                  </label>
                  
                  <label class="mr-1 m-0 p-0" for="amount">Comment
                  <textarea type="text" class="form-control" v-model="comment"  placeholder=""></textarea>
                  </label>
                   <label class="mx-1" for="amount">Payable Amount
                  <input type="number" class="form-control"  placeholder="Due Amount">
                  </label> -->

          <div class="col-md-12 mt-4 text-right">
            <button class="btn btn-primary" @click="createLead">Send</button>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      hide-footer
      ref="send-sms"
      scrollable
      id="send-sms"
      size="xl"
      title="Send SMS to Customer"
    >
      <sms :metaData="sendSmsMetaData" :id="send_sms_id"></sms>
    </b-modal>
    <b-modal hide-footer v-model="changeStatusModal" ref="changeStatusModal" scrollable  id="send-sms" size="xl" title="Change status">
      <changeFlag :metaData="changeStatusMetaData" :id="changeStatusId"></changeFlag>
    </b-modal>
  </div>
</template>
<script>
const axios = require("axios");
const moment = require("moment");
import * as _ from "lodash";
import json from "../../../Inventory/flags";
import responsivenessData from "../../../Inventory/responsiveness"

export default {
  data() {
    return {
      changeStatusMetaData: '',
      changeStatusId: '',
      responsivenessData: responsivenessData,
      sendSmsMetaData: "",
      flagsJson: json,
      commentData: [],
      status: 18,
      showModal: false,
      action: "",
      comment: "",
      edit_id: "",
      comment_previous: "",
      status_to_change: "",
      model_selected: "",
      fromDate: null,
      toDate: null,
      showsmsModal: false,
      sms: "",
      send_sms_id: "",
      send_sms_mobile: "",
      sendingsms: false,
      message_sent: "",
      loadingChat: true,
      showEdit: false,
      test: "",
      remind: "",
      reminder_date: "",
      changing: false,
      search: "",
      limit: 10,
      customerName: "",
      model: "",
      selectedItem: "",
      loadingComments: false,
      customer_id: "",

      sendSquadModel: false,

      paylink: "",

      additional_notes: "",
      not_interested_reason: "",
      leadID: "",
      name: "",
      phone: "",
      email: "",
      rental: "",
      vehicle_interested: "",
      registration_date: "",
    };
  },
  beforeCreate() {
    // const x = this.$route.query.id
    // if(x){
    // this.status = 1
    // this.search = x
    // }else{
    //   return
    // }
    if (this.agent_id === "" && this.username === "") {
      this.$router.push("/login");
    }
    this.$store.dispatch("get_waitlist");
  },
  mounted() {
    this.$store.dispatch("get_models");
    this.$store.dispatch("get_agents");
  },
  methods: {
    checkVariant(data){ 
      if(data != null){
        var x =  this.responsivenessData.filter(x=>{
          return x.activeStatus === data
        })
        if(x.length > 0){
          return x
        }else{
          return [{
          activeStatus: data,
          color: '#f1f1f1',
          description: 'Not Defined'
        }]
        }
      }else{
        return [{
          activeStatus: data,
          color: '#f1f1f1',
          description: 'Not Defined'
        }]
      }
    },
    openProfile(id, mobile) {
      this.$router.push({ path: "/userProfile/" + id + "/" + mobile });
    },
    load(id) {
      let x = this.templates.filter((x) => {
        return x.id == id;
      });
      window.console.log(x);
      this.sms = x[0].temp;
    },
    checkModel(word, sentence) {
      let sent = sentence;
      let first_word = [];
      first_word = sent.split(" ", 2);
      if (first_word[0] === word) {
        return true;
      } else {
        return false;
      }
    },
    editMobile() {
      this.$refs.typeBox.focus();
    },
    changestatus(id) {
      this.status = id;
    },
    closeModal() {
      this.showModal = false;
      (this.comment_previous = ""), (this.comment = ""), (this.edit_id = "");
    },
    closeSmsModal() {
      this.send_sms_id = "";
      this.send_sms_mobile = "";
      this.sms = "";
      this.showsmsModal = false;
      this.loadingChat = true;
    },
    agentName(id) {
      window.console.log(id);
      const x = this.agents.filter((x) => {
        return x.id == id;
      });
      return x[0].userName;
    },
    scrollToEnd: function() {
      var container = this.$el.querySelector("#container");
      container.scrollTop = container.scrollHeight;
    },
    openChangeStatusModel (bookingId, status, status_name, comment, customerId) {
      this.changeStatusId = customerId
      var obj = {
        flag: status,
        funnel: status_name,
        bookingId: bookingId,
        funnelUrl: 'waitlist',
        dispatch: 'get_waitlist',
      }
      this.changeStatusMetaData = obj
      this.$refs['changeStatusModal'].show()
    },
    openModal(id, status, name, comment, customerID) {
      this.loadingComments = true;
      window.console.log(id);
      axios
        .post(
          "https://api.on-track.in/api/getAgentCommentData",
          {
            bookingId: customerID,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((res) => {
          this.loadingComments = false;
          window.console.log(res.data);
          this.commentData = res.data;
          this.customer_id = customerID;
          this.edit_id = id;
          this.status_to_change = status;
          this.action = name;
          this.comment_previous = comment;
          this.showModal = true;
          setTimeout(() => {
            this.scrollToEnd();
          }, 1000);
        })
        .catch(() => {
          this.$toasted.global.my_app_error();
          this.loadingComments = false;
        });
    },
    opensmsModal(id, mobile, customerName, model) {
      // this.fetchMessages(id);
      // this.send_sms_id = id;
      // this.send_sms_mobile = mobile;
      // this.customerName = customerName;
      // this.model = model;
      // this.showsmsModal = true;
      this.send_sms_id = id;
      var obj = {
        mobile: mobile,
        modelName: model,
        Name: customerName,
      };
      this.sendSmsMetaData = obj;
      this.$refs["send-sms"].show(); 
    },
    squadVoice() {
      // this.$toasted.show('Adding up soon!',{
      //       type:'error',
      //       position:'bottom-center',
      //       duration:1000,
      //       theme:'bubble'
      // })

      this.sendSquadModel = true;
      // this.leadID = this.selectedItem.id
      // this.name = this.selectedItem.name
      // this.phone = this.selectedItem.mobile
      // this.email = this.selectedItem.email
      // this.rental = this.selectedItem.rental
      // this.vehicle_interested = this.selectedItem.model,
      // this.registration_date = this.selectedItem.regn_date
    },
    createLead() {
      axios
        .post(
          "https://corsanywhere.herokuapp.com/https://app.squadrun.co/api/v4/leads/create/KJLHY1/",
          {
            lead_id: this.selectedItem.id,
            phone_number: this.selectedItem.mobile,
            contact_name: this.selectedItem.name,
            lead_source: "WEB",
            lead_email: this.selectedItem.emailId,
            waitlist_date: this.selectedItem.createdAt,
            vehicle_type: "NA",
            unique_payment_link: "NA",
            waitlist_vehicle: this.selectedItem.model,
            registration_date: this.selectedItem.createdAt,
            status: 0,
            additional_notes: this.additional_notes,
            sv_outcome: "NA",
            not_interested_reason: "NA",
            judged_time: "NA",
            sv_lead_create_date: "NA",
            website_link: "book.on-track.in",
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer UuEkCLwr5dfkkAtflkRyMSG0YE8CWD",
            },
          }
        )
        .then(() => {
          axios
            .post(
              "https://api.on-track.in/api/updateWaitlist",
              {
                comment: "Sent to squadVoice",
                status: 10,
                id: this.selectedItem.id,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
                },
              }
            )
            .then(() => {
              this.sendSquadModel = false;
              this.$toasted.show("Done!", {
                type: "success",
                position: "bottom-center",
                duration: 1000,
                theme: "bubble",
              });
              this.$store.dispatch("get_waitlist");
            });
        })
        .catch(() => {
          this.$toasted.show("Some error occured!", {
            type: "error",
            position: "bottom-center",
            duration: 1000,
            theme: "bubble",
          });
          this.$store.dispatch("get_waitlist");
        });

      // axios.post('https://app.squadrun.co/api/v4/leads/create/VIZRW1/',{
      //             lead_id : "test_123456",
      //             phone_number : 7602743422,
      //             contact_name : "Abhinash",
      //             lead_source:"WEB",
      //             lead_email:"test@on-track.in",
      //             registration_date:"2018-12-03T14:37:54+00:00",
      //             vehicle_type:"NA",
      //             unique_payment_link:"NA",
      //             booking_date:"2018-12-03T14:37:54+00:00",
      //             vehicle_interested:"Honda",
      //             status:0,
      //             additional_notes:"na",
      //             sv_outcome:"na",
      //             not_interested_reason:"na",
      //             judged_time:"na",
      //             sv_lead_create_date:"na",
      //             website_link:"book.on-track.in"
      //     },{
      //       headers: {
      //             'Content-Type':  'application/json',
      //             'Authorization': 'Bearer UuEkCLwr5dfkkAtflkRyMSG0YE8CWD',
      //             'Access-Control-Allow-Origin': '*'
      //       }
      //       })
      //     .then((res)=>{
      //             alert(res.body)
      //       })
    },
    reset() {
      this.selectedItem = "";
    },
    sendPromition(id, mobile) {
      this.$router.push({
        path: "/sendNotification",
        query: { mobile: mobile, id: id },
      });
    },
    openModalbydrag(status, name, comment) {
      this.action = name;
      this.comment = comment;
      this.showModal = true;
    },
    handleDrop(data) {
      alert("yeahh" + data);
    },
    setid(data) {
      this.comment = data.comment;
      this.edit_id = data.id;
      window.console.log(this.comment);
    },
    change_status() {
      this.changing = true;
      axios
        .post(
          "https://api.on-track.in/api/addToAgentComment",
          {
            bookingId: this.customer_id,
            agentId: this.agent_id,
            comment: this.comment,
            current_flag: this.status_to_change,
            current_status: this.status_computed,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          axios
            .post(
              "https://api.on-track.in/api/updateWaitlist",
              {
                comment: this.comments_all,
                status: this.status_to_change,
                id: this.edit_id,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
                },
              }
            )
            .then(() => {
              if (this.remind) {
                window.db
                  .collection("reminder")
                  .add({
                    reminder_date: this.reminder_date,
                    remind_status: 0,
                    read: 0,
                    message: this.comment,
                    date: this.date,
                    id: this.edit_id,
                    table: "waitlist",
                  })
                  .then(() => {
                    this.showModal = false;
                    this.comment = "";
                    this.$store.dispatch("get_waitlist");
                    this.changing = false;
                  });
              } else {
                this.showModal = false;
                this.comment = "";
                this.$store.dispatch("get_waitlist");
                this.changing = false;
              }
            });
        })
        .catch((err) => {
          this.message = err.msg;
          this.$toasted.global.my_app_error();
          this.changing = false;
          this.selectedItem = "";
        });
    },
    sendMessage() {
      this.sendingsms = true;
      axios
        .post(
          "https://api.on-track.in/api/sendSms",
          {
            mobile: this.send_sms_mobile,
            msg: this.sms,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then(() => {
          window.db
            .collection("sent_sms")
            .add({
              id: this.send_sms_id,
              mobile: this.send_sms_mobile,
              createdAt: new Date().toString("hh:mm tt"),
              agent: this.username,
              agent_id: this.agent_id,
              sms: this.sms,
            })
            .then(() => {
              // this.scrollToBottom()
              this.sendingsms = false;
              // console.log("Document written with ID: ", docRef.id);
              this.send_sms_id = "";
              this.send_sms_mobile = "";
              this.sms = "";
              // this.showsmsModal = false
              // this.message=''
            })
            .catch(function(error) {
              this.sendingsms = false;
              console.error("Error adding document: ", error);
              this.message = "";
              this.$toasted.global.my_app_error();
            });
        })
        .catch(() => {
          this.sendingsms = false;
          this.$toasted.global.my_app_error();
        });
    },
    fetchMessages(id) {
      window.db
        .collection("sent_sms")
        .where("id", "==", id)
        .onSnapshot((querySnapshot) => {
          let allMessages = [];
          querySnapshot.forEach((doc) => {
            allMessages.push(doc.data());
          });
          this.message_sent = allMessages;
          this.loadingChat = false;
          // setTimeout(()=>{
          //       this.scrollToBottom()
          // },1000)
        });
    },
  },
  computed: {
    changeStatusModal : {
        get () {
          return this.$store.state.changeStatusModal
        },
        set (newValue){
          this.$store.state.changeStatusModal = newValue
        }      
    },
    templates() {
      return [
        {
          id: 1,
          tag: "Direction",
          temp: `Hi ${this.customerName}, We are located at 22, Hosur Main Road, Dairy Colony, Adugodi, Bengaluru, Karnataka 560029. GMap link : https://goo.gl/maps/ezNviFpLxjJupGvj
Landmark : Big Bazaar basement , -2 floor
For any further assistance please call 9148518401.`,
        },
        {
          id: 2,
          tag: "Bike Available",
          temp: `Hi ${
            this.customerName
          }, I tried to call you on ${moment().format(
            "ll"
          )} but I was unable to connect with you, We noticed that you have registered yourself on our application looking to rent ${
            this.model
          }. Vehicle is available now, feel free to proceed booking with us.`,
        },
        {
          id: 3,
          tag: "Bike Unvailable",
          temp: `Hi ${
            this.customerName
          }, I tried to call you on ${moment().format(
            "ll"
          )} but I was unable to connect with you due to <>, We noticed that you have registered yourself on our application looking to rent ${
            this.model
          }. For any assistance with booking please call 9148518401.`,
        },
        {
          id: 4,
          tag: "Not Interested",
          temp: `Hi ${this.customerName} It was a pleasure talking with you, We are always here if you wish to get a bike from us.`,
        },
        {
          id: 5,
          tag: "Coupon",
          temp: `Use coupon code <> to get flat Rs <> off on your booking. Offer valid on select models.`,
        },
      ];
    },
    takeDate() {
      if (this.remind == true) {
        return true;
      } else {
        return false;
      }
    },
    agent_id() {
      return localStorage.getItem("agent_id");
    },
    username() {
      return localStorage.getItem("username");
    },
    loading() {
      return this.$store.state.makingAJAX;
    },
    waitlist() {
      return this.$store.getters.waitlistdata(this.status_computed);
    },
    agents() {
      return this.$store.state.agents;
    },

    // test(){
    //        return this.$store.getters.demo
    // },
    filteredList() {
      return this.waitlist.filter((post) => {
        return (
          post.name.toLowerCase().includes(this.search.toLowerCase()) ||
          post.customerId.toString().includes(this.search.toLowerCase()) ||
          post.mobile.toString().includes(this.search.toLowerCase())
        );
      });
    },
    filteredbydates() {
      var vm = this;
      var start = vm.fromDate;
      var end = vm.toDate;
      return _.filter(this.filteredList, function(data) {
        if (_.isNull(start) && _.isNull(end)) {
          return true;
        } else {
          var date = moment(data.createdAt).format("YYYY-MM-DD");
          return date >= start && date <= end;
        }
      });
    },
    waitlist_filtered() {
      if (this.model_selected === "") {
        return this.filteredbydates;
      } else {
        return this.filteredbydates.filter((data) => {
          return data.model === this.model_selected;
        });
      }
    },
    limited() {
      return this.waitlist_filtered.slice(0, this.limit);
    },
    models() {
      return this.$store.state.models_list;
    },
    status_computed() {
      return this.status;
    },
    waitlist_count() {
      return this.$store.getters.waitlist_count;
    },
    totalCount() {
      return (
        this.waitlist_count.new +
        this.waitlist_count.squadVoice +
        this.waitlist_count.postponed +
        this.waitlist_count.action_taken +
        this.waitlist_count.not_interested +
        this.waitlist_count.successful
      );
    },
    newCount() {
      return Math.round((this.waitlist_count.new / this.totalCount) * 100) || 0;
    },
    postponedCount() {
      return (
        Math.round((this.waitlist_count.postponed / this.totalCount) * 100) || 0
      );
    },
    action_takenCount() {
      return (
        Math.round(
          (this.waitlist_count.action_taken / this.totalCount) * 100
        ) || 0
      );
    },
    notInterestedCount() {
      return (
        Math.round(
          (this.waitlist_count.not_interested / this.totalCount) * 100
        ) || 0
      );
    },
    sucessCount() {
      return (
        Math.round((this.waitlist_count.successful / this.totalCount) * 100) ||
        0
      );
    },
    squadVoiceCount() {
      return (
        Math.round((this.waitlist_count.squadVoice / this.totalCount) * 100) ||
        0
      );
    },
    comments_all() {
      return `${this.comment}-${this.username} at ${this.date}`;
    },

    date() {
      var date = new Date();
      var month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var day = date.getDate();
      var year = date.getFullYear();
      return day + "/" + month + "/" + year;
    },
    Percentage_total() {
      return (
        Math.round((this.waitlist_filtered.length / this.totalCount) * 100) || 0
      );
    },
    percentage_new() {
      return (
        Math.round(
          (this.waitlist_filtered.length / this.waitlist_count.new) * 100
        ) || 0
      );
    },
    percentage_postponed() {
      return (
        Math.round(
          (this.waitlist_filtered.length / this.waitlist_count.postponed) * 100
        ) || 0
      );
    },
    percentage_underAction() {
      return (
        Math.round(
          (this.waitlist_filtered.length / this.waitlist_count.action_taken) *
            100
        ) || 0
      );
    },
    percentage_not_interested() {
      return (
        Math.round(
          (this.waitlist_filtered.length / this.waitlist_count.not_interested) *
            100
        ) || 0
      );
    },
    percentage_success() {
      return (
        Math.round(
          (this.waitlist_filtered.length / this.waitlist_count.successful) * 100
        ) || 0
      );
    },
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Questrial&display=swap");
.link:hover {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
.cancel {
  background-color: white;
  border-radius: 10px;
}
.hand2 {
  cursor: pointer;
  background-color: rgb(217, 230, 252);
  border-radius: 10px;
  font-size: 12px;
}
.hand2:hover {
  background-color: rgb(166, 194, 240);
}
.hand21 {
  cursor: pointer;
  background-color: rgb(230, 238, 251);
  border-radius: 15px;
}
@media only screen and (max-width: 600px) {
  .scrolling-wrapper {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
  }
  .scrolling-wrapper::-webkit-scrollbar {
    display: none;
  }
  .scrolling-wrapper .card {
    display: inline-block;
    margin: 0 5px;
  }
  .drop h3,
  table {
    font-size: 12px !important;
  }
}
.waitlist h3 {
  font-size: 18px;
}
.filtering label {
  font-size: 15px;
}
.dropdown-menu {
  font-size: 12px;
}
.table .dropdown-toggle {
  font-size: 13px !important;
}
.show_hand {
  cursor: pointer;
  text-align: center;
  box-shadow: 0 1px 3px rgba(36, 39, 44, 0.15);
}
.table {
  text-align: left;
}
.table td {
  padding: 5px;
}
.drop h3 {
  font-size: 11px;
}
.table td,
th {
  padding: 5px;
  padding-left: 0px;
}

.modal-header {
  font-size: 20px;
}

.active_card {
  border-top: 5px solid rgb(244, 128, 36);
  background-color: rgb(244, 128, 36, 0.2);
  /* color: white;      */
}
.active_card .wrapper-progress {
  color: black;
}
.active_card .progress {
  background-color: rgb(244, 128, 36);
}
.dropdown-item {
  cursor: pointer;
}
.percentage {
  font-size: 13px;
}
.modals {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999999; /* Sit on top */
  padding-top: 10px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}
.displayModal {
  display: block !important;
}
/* modals Content */
.modals-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 50%;
}

.modals-content-90 {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 90%;
}

@media only screen and (max-width: 600px) {
  .modals-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 95%;
    font-size: 15px;
  }

  .news {
    margin-left: 0 !important;
  }
  .filtering {
    display: block !important;
  }
  .date_picker {
    display: block !important;
  }
  .button-on {
    margin-top: 10px;
  }
}
/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
.drag {
  cursor: move;
}
.new {
  background-color: #e74c3c;
}
.postponed {
  background-color: #e67e22;
}
.action_taken {
  background-color: #1abc9c;
}
.under_action {
  background-color: #9b59b6;
}
.success {
  background-color: #2ecc71;
}
#tooltip2 {
  position: relative;
}
#tooltip2 span {
  display: none;
  color: #000000;
}
#tooltip2:hover span {
  display: block;
  position: absolute;
  width: 100px !important;
  text-align: center;
  height: auto;
  right: 1px;
  border-radius: 5px;
  font-size: 11px;
  top: -13px;
  color: #ffffff !important;
  background-color: rgb(0, 0, 0, 0.6);
  padding: 0 5px;
}
.previous .lead {
  color: red;
  font-size: 12px;
}
.previous {
  font-size: 17px;
}
.ontrack-button {
  border: none;
  padding: 5px;
  background-color: rgb(244, 128, 36, 0.7);
  color: white;
  width: 35%;
  font-size: 16px;
}
/* .wrapper{
       background-color:#5F72E4 !important;     
} */
.ontrack-button:hover {
  background-color: rgb(244, 128, 36);
}
.discription {
  font-size: 12px;
  color: gray;
}
.sms {
  font-size: 14px;
}
.tag {
  color: green;
  font-size: 10px;
}
.hand {
  cursor: pointer;
}
.templates {
  max-height: 300px;
  overflow: scroll;
  font-size: 13px;
}
#tooltip {
  position: relative;
}
#tooltip span {
  display: none;
  color: #000000;
}
#tooltip:hover span {
  display: block;
  position: absolute;
  width: 300px;
  height: auto;
  left: 60px;
  font-size: 11px;
  border-radius: 5px;
  top: -7px;
  text-align: center;
  color: white;
  padding: 5px 5px;
  background-color: rgb(0, 0, 0, 0.6);
  cursor: pointer;
}
#tooltip1 {
  position: relative;
}
#tooltip1 span {
  display: none;
  color: #000000;
}
#tooltip1:hover span {
  display: block;
  position: absolute;
  width: 90px;
  height: auto;
  left: 60px;
  font-size: 11px;
  border-radius: 5px;
  top: -7px;
  text-align: center;
  color: white;
  padding: 5px 5px;
  background-color: rgb(0, 0, 0, 0.6);
  cursor: pointer;
}
/* #tooltip2 { position: relative; }
#tooltip2 span { display: none; color: #000000; }
#tooltip2:hover span { display: block;
position: absolute; width: 100%;
height: auto; right: 30px;
border-radius: 5px;
font-size: 11px;
top: -20px;
color: #000000;
padding: 0 5px;
} */
.phone_input {
  border: none;
  padding: 0px !important;
  width: 120px;
}
.handy {
  /* background-color: rgb(217, 230, 252); */
  cursor: pointer;
  border: none !important;
  outline: none;
}
.size_12 {
  font-size: 12px;
}
.show_edit {
  border: 1px solid black !important;
}

/* .wrapper-progress{
  width: 100%;
  border: 1px solid #F48024
}
.progress{
  border-radius: 0px;
  background: repeating-linear-gradient(45deg, #F0C153, #F0C153 2px, #F48024 2px, #F48024 4px);
}
*/
.percent-progress {
  position: absolute;
}
.previousComment {
  max-height: 250px;
  position: relative;
  overflow-y: auto;
  background-color: whitesmoke;
  scroll-behavior: smooth;
}
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  display: none;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(244, 128, 36, 0.8);
  border-radius: 1px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(244, 128, 36);
}

.highlight {
  font-size: 15px;
  color: rgb(244, 128, 36);
}
.modal-heading {
  background: rgb(255, 255, 255);
  box-shadow: 0 1px 3px rgba(36, 39, 44, 0.15);
  color: black;
  margin-bottom: 3px !important;
}

.hand {
  cursor: pointer;
}
</style>
